import { render, staticRenderFns } from "./BodyweightSetting.vue?vue&type=template&id=3690a2ea"
import script from "./BodyweightSetting.vue?vue&type=script&lang=js"
export * from "./BodyweightSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports